
<div class="leave-settings-page" dir="rtl">
  <div class="leave-settings-container">

    <!-- عنوان صفحه -->
    <div class="page-heading">
      <div class="page-heading-icon">
        <i class="fa fa-sliders"></i>
      </div>
      <div>
        <h3>تنظیمات سقف مجاز مرخصی</h3>
        <p>
          مدیریت حداکثر مرخصی مجاز کارکنان در ماه و سال شمسی
        </p>
      </div>
    </div>

    <!-- راهنما -->
    <div class="settings-guide">
      <i class="fa fa-info-circle"></i>
      <span>
        این تنظیمات برای همه کارکنان اعمال می‌شود.
        مقدار خالی به معنی بدون محدودیت و مقدار صفر
        به معنی عدم امکان استفاده از مرخصی است.
      </span>
    </div>

    <!-- پیام‌ها -->
    <div *ngIf="loading" class="settings-message" role="status">
      <i class="fa fa-spinner fa-spin"></i>
      در حال دریافت تنظیمات...
    </div>

    <div *ngIf="error" class="alert alert-danger" role="alert">
      {{ error }}
    </div>

    <div *ngIf="saved" class="alert alert-success" role="status">
      <i class="fa fa-check-circle"></i>
      تنظیمات با موفقیت ذخیره شد.
    </div>

    <form [formGroup]="form" (ngSubmit)="save()">

      <div class="row settings-cards">

        <!-- کارت مرخصی ساعتی -->
        <div class="col-lg-6 mb-4">
          <section class="setting-card hourly-card">

            <div class="setting-card-header">
              <div class="setting-icon hourly-icon">
                <i class="fa fa-clock-o"></i>
              </div>

              <div>
                <h4>مرخصی ساعتی</h4>
                <p>تعیین سقف مجاز بر حسب ساعت</p>
              </div>
            </div>

            <div class="setting-card-body">

              <div
                *ngFor="let field of fields.slice(0, 2)"
                class="setting-field">

                <label [for]="field.key">
                  {{ field.title }}
                </label>

                <div class="field-input-wrapper">
                  <input
                    type="number"
                    class="form-control"
                    [id]="field.key"
                    [formControlName]="field.key"
                    min="0"
                    max="99999999.99"
                    step="0.01"
                    placeholder="بدون محدودیت"
                    [readOnly]="saving || loading">

                  <span class="field-unit">ساعت</span>
                </div>

                <small
                  class="text-danger field-error"
                  *ngIf="form.get(field.key)?.invalid &&
                    (form.get(field.key)?.dirty ||
                     form.get(field.key)?.touched)">
                  عدد نامنفی با حداکثر دو رقم اعشار وارد کنید.
                </small>

              </div>

            </div>
          </section>
        </div>

        <!-- کارت مرخصی روزانه -->
        <div class="col-lg-6 mb-4">
          <section class="setting-card daily-card">

            <div class="setting-card-header">
              <div class="setting-icon daily-icon">
                <i class="fa fa-calendar-check-o"></i>
              </div>

              <div>
                <h4>مرخصی روزانه</h4>
                <p>تعیین سقف مجاز بر حسب روز</p>
              </div>
            </div>

            <div class="setting-card-body">

              <div
                *ngFor="let field of fields.slice(2, 4)"
                class="setting-field">

                <label [for]="field.key">
                  {{ field.title }}
                </label>

                <div class="field-input-wrapper">
                  <input
                    type="number"
                    class="form-control"
                    [id]="field.key"
                    [formControlName]="field.key"
                    min="0"
                    max="99999999.99"
                    step="0.01"
                    placeholder="بدون محدودیت"
                    [readOnly]="saving || loading">

                  <span class="field-unit">روز</span>
                </div>

                <small
                  class="text-danger field-error"
                  *ngIf="form.get(field.key)?.invalid &&
                    (form.get(field.key)?.dirty ||
                     form.get(field.key)?.touched)">
                  عدد نامنفی با حداکثر دو رقم اعشار وارد کنید.
                </small>

              </div>

            </div>
          </section>
        </div>

      </div>

      <!-- دکمه ذخیره -->
      <div class="settings-actions">
        <span class="save-hint">
          <i class="fa fa-shield"></i>
          تغییرات پس از ذخیره برای درخواست‌های جدید اعمال می‌شود.
        </span>

        <button
          type="submit"
          class="btn save-button"
          [disabled]="loading || saving || form.disabled || form.invalid">

          <i
            class="fa"
            [ngClass]="saving ? 'fa-spinner fa-spin' : 'fa-save'">
          </i>

          {{ saving ? 'در حال ذخیره...' : 'ذخیره تنظیمات' }}
        </button>
      </div>

    </form>
  </div>
</div>
